// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_Container__70pDi {
  height: 0;
  flex-grow: 1;
  display: flex;
  width: 100%;
  overflow: clip;
  position: relative;
}
.styles_Container__70pDi::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}
.styles_Container__70pDi::-webkit-scrollbar-thumb {
  background: #bec2c5;
}
.styles_Container__70pDi::-webkit-scrollbar-track {
  background: #e9ecef;
}
.styles_Container__70pDi {
  scrollbar-face-color: #bec2c5;
  scrollbar-track-color: #e9ecef;
}

.styles_LeftPanel__yo0Cm {
  width: 30%;
  overflow-y: auto;
  height: 100%;
}

.styles_RightPanel__TMW2g {
  display: flex;
  width: 70%;
  height: 100%;
}

.styles_Disclaimer__XF075 {
  background-color: #F5F5F5;
  padding: 16px 10px 5px 20px;
  border-bottom: 1px solid #dee2e6;
  font-size: 13px;
  z-index: 1000;
}

.styles_DisclaimerTitle__oCkGZ {
  font-size: 16px;
  font-weight: 600;
}

.styles_main__48czx {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/Simulation/styles.module.scss","webpack://./src/styles/global-variables.scss"],"names":[],"mappings":"AAqBA;EAEE,SAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AArBF;AALE;EACE,aAmBkB;EAlBlB,cAkBkB;AAXtB;AAJE;EACE,mBAc0B;AAR9B;AAHE;EACE,mBAUmC;AALvC;AAFE;EACE,6BAM0B;EAL1B,8BAKmC;AADvC;;AAUA;EACE,UAAA;EACA,gBAAA;EACA,YAAA;AAPF;;AAUA;EACE,aAAA;EACA,UAAA;EACA,YAAA;AAPF;;AAUA;EACE,yBAAA;EACA,2BAAA;EACA,gCAAA;EACA,eAAA;EACA,aCrC2B;AD8B7B;;AAUA;EACE,eAAA;EACA,gBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;AAPF","sourcesContent":["@use \"/home/runner/_work/gmc-dc-pbui-fe/gmc-dc-pbui-fe/src/styles/global-variables.scss\" as *;\n@mixin scrollbars($size, $foreground-color, $background-color) {\n  &::-webkit-scrollbar {\n    width: $size;\n    height: $size;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $foreground-color;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: $background-color;\n  }\n\n  & {\n    scrollbar-face-color: $foreground-color;\n    scrollbar-track-color: $background-color;\n  }\n}\n\n.Container {\n  @include scrollbars(0.5rem, #bec2c5, #e9ecef);\n  height: 0;\n  flex-grow: 1;\n  display: flex;\n  width: 100%;\n  overflow: clip;\n  position: relative;\n}\n\n.LeftPanel {\n  width: 30%;\n  overflow-y: auto;\n  height: 100%;\n}\n\n.RightPanel {\n  display: flex;\n  width: 70%;\n  height: 100%;\n}\n\n.Disclaimer {\n  background-color: #F5F5F5;\n  padding: 16px 10px 5px 20px;\n  border-bottom: 1px solid $borderColor;\n  font-size: 13px;\n  z-index: $zIndexSimulationDisclaimer;\n}\n\n.DisclaimerTitle {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.main {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex-grow: 1;\n}","$navbarHeight: 50px;\n\n$clearSectionButtonColor: #6C757D;\n$clearAllButtonPrimary: #F8F9FA;\n$clearAllButtonDisabled: #A1BFBE;\n$borderColor: #dee2e6;\n\n$buttonBorderRadius: 3.2px;\n\n$buttonFontSize: 14px;\n\n$zIndexSimulationDisclaimer: 1000;\n$zIndexSectionWithLayoutVariantsHover: 200;\n$zIndexSectionHighlighted: 100;\n$zIndexSectionStickyPanel: 100;\n$zIndexModal: 100;\n$zIndexModalBackdrop: 10;\n$zIndexIconTitleTooltip: 2;\n$zIndexScreen: 2;\n$zIndexScreenBackdrop: 1;\n$zIndexLayoutPreviewListStickyPanel: 1;\n$zIndexTextCollectionsModalTh: 1;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `styles_Container__70pDi`,
	"LeftPanel": `styles_LeftPanel__yo0Cm`,
	"RightPanel": `styles_RightPanel__TMW2g`,
	"Disclaimer": `styles_Disclaimer__XF075`,
	"DisclaimerTitle": `styles_DisclaimerTitle__oCkGZ`,
	"main": `styles_main__48czx`
};
export default ___CSS_LOADER_EXPORT___;
